import { useNavigate, useSearchParams } from 'react-router-dom';
import { RoutesList } from '@bikes/routes/Routes';
import { useBikesStore } from '@bikes/store/store';
import { FunctionComponent, useEffect } from 'react';
import {
  BikesType,
  BikesTypeLabel,
} from '@bikes/store/storeSlices/bikesDetails';
import { CallToActionCardProps } from '@molecules/';
import { HireContent } from './HireContent';
import { PersonalBikeContent } from './PersonalBikeContent';
import { v4 as uuidv4 } from 'uuid';
import {
  FORM_LINK_TEXT,
  FORM_LINK_SUBTEXT,
  CHAT_LINK_TEXT,
  CHAT_LINK_SUBTEXT,
} from '@constants';

const ASSISTANT_URL = import.meta.env.VITE_ASSISTANT_URL;

export const BeforeYouStart: FunctionComponent = () => {
  const navigate = useNavigate();
  const {
    updateBikesType,
    bikesType,
    updateHireCompany,
    updateSessionId,
    resetBikesDetails,
    resetYourDetails,
    resetConfirmationInformation,
    updateCaseReferenceId,
  } = useBikesStore();
  const [searchParams] = useSearchParams();
  const paramsType = (searchParams.get('type') || BikesType.Bikes) as BikesType;
  const contentTitle = `Report a ${BikesTypeLabel[bikesType as BikesType]} issue`;

  const sessionId = uuidv4();
  const initiateForm = () => {
    updateSessionId(sessionId);
    navigate(RoutesList.UPLOAD_PHOTO);
  };

  const assistantParam =
    paramsType === BikesType.Bikes ? 'bikes' : 'hire_bikes_hire_scooters';

  const reportItAssistantRoute = `${ASSISTANT_URL}?category=${assistantParam}`;
  const assistantCTA: CallToActionCardProps = {
    linkText: CHAT_LINK_TEXT,
    linkSubtext: CHAT_LINK_SUBTEXT,
    externalHref: reportItAssistantRoute,
  };

  const reportItCTA: CallToActionCardProps = {
    linkText: FORM_LINK_TEXT,
    linkSubtext: FORM_LINK_SUBTEXT,
    onClick: initiateForm,
  };
  const callToActionCards = [assistantCTA, reportItCTA];

  const linkObjectArrays = [
    {
      level: 1,
      title: 'Home',
      href: 'https://www.westminster.gov.uk/',
    },
    {
      level: 2,
      title: 'Report it',
      href: 'https://www.westminster.gov.uk/report-it',
    },
    {
      level: 3,
      title: `Report a ${BikesTypeLabel[bikesType as BikesType]} issue`,
    },
  ];

  useEffect(() => {
    if (
      bikesType === null ||
      (bikesType !== null && searchParams.get('type') !== null)
    ) {
      updateHireCompany(null);
      resetBikesDetails();
      // updateCaseReferenceId('');
      resetYourDetails();
      resetConfirmationInformation();
      updateBikesType(paramsType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramsType]);

  if (bikesType === 'bikes') {
    return (
      <PersonalBikeContent
        contentTitle={contentTitle}
        callToActionCards={callToActionCards}
        linkObjectArrays={linkObjectArrays}
      />
    );
  } else {
    return (
      <HireContent
        contentTitle={contentTitle}
        bikesType={bikesType as BikesType}
        callToActionCards={callToActionCards}
        linkObjectArrays={linkObjectArrays}
      />
    );
  }
};
